<template>
    <div id="summary-electric" class="modal-summary modal fade" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-heading text-uppercase">Calculation Summary</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="material-icons" aria-hidden="true">clear</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="summary-header">
              <div class="summary-header-item meta">
                <span class="vehicle font-heading">Peterbilt {{ vehicle['name'] }}</span>
                <span class="category text-uppercase font-heading">{{ vehicle['fuel']['type'] }}</span>
                <span class="vehicle-img"><img :src="vehicle['icon']" :alt="vehicle['name']"></span>
              </div>
              <div class="summary-header-item fleet-size">
                <div class="form-group form-group-inline mb-0">
                    <label for="fleetSize">Fleet Size</label>
                    <input type="number" id="fleetSize" name="fleetSize" class="range-output" min="0" max="500" v-model="fleetSize" @change="trackFleetSize()">
                </div>
              </div>
              <!-- <div class="summary-header-item print">
                <button class="btn btn-outline-primary btn-block">Print Summary</button>
              </div> -->
            </div>
            <div class="summary-calculations">
              <div class="calculation fuel">
                <span class="calculation-title font-heading">Electric Costs</span>
                <div class="item">
                  <div class="calc-desc">
                    <span class="font-bold">Annual Cost (Per Vehicle)</span>
                    <small v-if="usage == 'miles'">Mileage * Electricity Cost + PTO Totals =</small>
                    <small v-if="usage == 'hours'">Hours * Electricity Cost + PTO Totals =</small>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right">{{ formatPrice(fuelCost['annual-cost'] * currencyExchange, 0) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right">{{ formatPrice(fuelCost['annual-cost-hourly'] * currencyExchange, 0) }}</div>
                </div>
                <div class="item mt-3">
                  <div class="calc-desc">
                    <span class="font-bold">Fleet Size</span>
                  </div>
                  <div class="calc-value text-right">x{{ fleetSize }}</div>
                </div>

                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span class="font-bold text-primary">Electric Totals =</span>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right font-bold">{{ formatPrice(fleetSize * (fuelCost['annual-cost'] * currencyExchange), 0) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right font-bold">{{ formatPrice(fleetSize * (fuelCost['annual-cost-hourly'] * currencyExchange), 0) }}</div>
                </div>

                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span v-if="usage == 'miles'" class="font-bold">Cost Per Mile  (Per Vehicle)</span>
                    <span v-if="usage == 'hours'" class="font-bold">Cost Per Hour  (Per Vehicle)</span>
                    <small v-if="usage == 'miles'">Annual Cost / Mileage =</small>
                    <small v-if="usage == 'hours'">Annual Cost / Hours =</small>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right">{{ formatPrice(fuelCost['cost-per-mile'] * currencyExchange) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right">{{ formatPrice(fuelCost['cost-per-hour'] * currencyExchange) }}</div>
                </div>
                
              </div>

              <div class="calculation equipment">
                <span class="calculation-title font-heading">Equipment Costs</span>
                <div class="item">
                  <div class="calc-desc pr-5">
                    <span class="font-bold">Annual Cost (Per Vehicle)</span>
                    <small>(Vehicle Price + Resale + Charger - Rebate Credit) / Amortization =</small>
                  </div>
                  <div class="calc-value text-right">{{ formatPrice(equipment['annual-cost'] * currencyExchange, 0) }}</div>
                </div>
                <div class="item mt-3">
                  <div class="calc-desc">
                    <span class="font-bold">Fleet Size</span>
                  </div>
                  <div class="calc-value text-right">x{{ fleetSize }}</div>
                </div>
                
                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span class="font-bold text-primary">Equipment Totals =</span>
                  </div>
                  <div class="calc-value text-right font-bold">{{ formatPrice(fleetSize * (equipment['annual-cost'] * currencyExchange), 0) }}</div>
                </div>
                
                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span v-if="usage == 'miles'" class="font-bold">Cost Per Mile  (Per Vehicle)</span>
                    <span v-if="usage == 'hours'" class="font-bold">Cost Per Hour  (Per Vehicle)</span>
                    <small v-if="usage == 'miles'">Equipment Cost / Mileage =</small>
                    <small v-if="usage == 'hours'">Equipment Cost / Hours =</small>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right">{{ formatPrice(equipment['cost-per-mile'] * currencyExchange) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right">{{ formatPrice(equipment['cost-per-hour'] * currencyExchange) }}</div>
                </div>

                
              </div>

              <div class="calculation other">
                <span class="calculation-title font-heading">Other Costs</span>
                <div class="item">
                  <div class="calc-desc pr-5">
                    <span class="font-bold">Annual Cost (Per Vehicle)</span>
                    <small>Maintenance + Insurance + Taxes + Tolls + Wages =</small>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right">{{ formatPrice(otherCost['annual-cost'] * currencyExchange, 0) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right">{{ formatPrice(otherCost['annual-cost-hourly'] * currencyExchange, 0) }}</div>
                </div>
                <div class="item mt-3">
                  <div class="calc-desc">
                    <span class="font-bold">Fleet Size</span>
                  </div>
                  <div class="calc-value text-right">x{{ fleetSize }}</div>
                </div>

                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span class="font-bold text-primary">Other Totals =</span>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right font-bold">{{ formatPrice( fleetSize * (otherCost['annual-cost'] * currencyExchange), 0) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right font-bold">{{ formatPrice( fleetSize * (otherCost['annual-cost-hourly'] * currencyExchange), 0) }}</div>
                </div>

                <div class="item divider my-3"></div>

                <div class="item">
                  <div class="calc-desc">
                    <span v-if="usage == 'miles'" class="font-bold">Cost Per Mile  (Per Vehicle)</span>
                    <span v-if="usage == 'hours'" class="font-bold">Cost Per Hour  (Per Vehicle)</span>
                    <small v-if="usage == 'miles'">Other Cost / Mileage =</small>
                    <small v-if="usage == 'hours'">Other Cost / Hours =</small>
                  </div>
                  <div v-if="usage == 'miles'" class="calc-value text-right">{{ formatPrice( otherCost['cost-per-mile'] * currencyExchange ) }}</div>
                  <div v-if="usage == 'hours'" class="calc-value text-right">{{ formatPrice( otherCost['cost-per-hour'] * currencyExchange ) }}</div>
                </div>
              </div>
            </div>
            <div class="summary-footer text-center">
              <div class="totals">
                <span class="font-heading">ESTIMATED ANNUAL OPERATING COST:</span>
                
                <div class="totals-output per-mile">
                  <span v-if="usage == 'miles'">{{ formatPrice( (fuelCost['cost-per-mile'] + equipment['cost-per-mile'] + otherCost['cost-per-mile']) * currencyExchange ) }}</span>
                  <span v-if="usage == 'hours'">{{ formatPrice( (fuelCost['cost-per-hour'] + equipment['cost-per-mile'] + otherCost['cost-per-hour']) * currencyExchange ) }}</span>
                  <span>Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }}</span>
                </div>
                
                <div class="totals-output per-year">
                  <span v-if="usage == 'miles'">{{ formatPrice( (fuelCost['annual-cost'] + equipment['annual-cost'] + otherCost['annual-cost']) * currencyExchange, 0) }}</span>
                  <span v-if="usage == 'hours'">{{ formatPrice( (fuelCost['annual-cost-hourly'] + equipment['annual-cost'] + otherCost['annual-cost-hourly']) * currencyExchange, 0) }}</span>
                  <span>Total Annual Cost</span>
                </div>
              </div>
              <div class="totals">
                <span class="font-heading">ESTIMATED ANNUAL FLEET OPERATING COST:</span>
                <div class="totals-output per-mile">
                  <span v-if="usage == 'miles'">{{ formatPrice( ((fuelCost['annual-cost'] + equipment['annual-cost'] + otherCost['annual-cost']) * currencyExchange) * fleetSize, 0) }}</span>
                  <span v-if="usage == 'hours'">{{ formatPrice( ((fuelCost['annual-cost-hourly'] + equipment['annual-cost'] + otherCost['annual-cost-hourly']) * currencyExchange) * fleetSize , 0) }}</span>
                  <span>Total Annual Fleet Cost</span>
                </div>
                <div class="totals-output per-year">
                  <span>x{{ fleetSize }}</span>
                  <span>Fleet Size</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'ElectricSummaryModal',
        props: {
          vehicle: {},
          fuelCost: {},
          equipment: {},
          otherCost: {},
          usage: String
        },
        data() {
          return {
            currencyType: '',
            currencyExchange: 0,
            fleetSize: 1
          }
        },
        mounted() {
          // Set currency
          this.currencyType = sessionStorage.getItem('currency')
          this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
        },
        methods: {
          formatPrice(value, spaces = 2) {
            let val = (value/1).toFixed(spaces)
            return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          },
          trackFleetSize() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Fleet Size',
                    'event_label': this.fleetSize
                })
            }
        }
    }
</script>